import React from "react";

export type WidgetContainerContextTypes = {
	authorizeWindow: any;
	setAuthorizeWindow: any;
	globalProps: any;
};

const values: WidgetContainerContextTypes = {
	authorizeWindow: "",
	setAuthorizeWindow: () => {},
	globalProps: {},
};

const WidgetContainerContext = React.createContext(values);
export default WidgetContainerContext;
